import React from "react";

const CreateAgentModal = ({
  apiMessage,
  apiMessageType,
  formData,
  errors,
  setFormData,
  setErrors,
  handleSubmit,
  closeModalRef,
}) => {
  return (
    <div
      className="modal fade"
      id="createAgentModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="createAgentLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="createAgentLabel">
              Create Agent
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" className="ki ki-close" />
            </button>
          </div>

          <div className="modal-body">
            {apiMessage && (
              <div className={`alert alert-${apiMessageType}`} role="alert">
                {apiMessage}
              </div>
            )}

            <form autoComplete="off">
              <div className="row">
                {/* Name */}

                <div className="col-md-12">
                  <label className="form-label">
                    Name
                    <span className="text-danger font-size-xs">*</span>
                  </label>

                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors?.name ? "invalid" : ""}`}
                    autoComplete="off"
                    value={formData.name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      });

                      setErrors({
                        ...errors,
                        name: e.target.value.trim() ? "" : "Name is mandatory",
                      });
                    }}
                  />

                  <p className="text-danger font-size-xs m-0">{errors?.name}</p>
                </div>

                {/* Mobile */}

                <div className="col-md-12 my-5">
                  <label className="form-label">
                    Mobile
                    <span className="text-danger font-size-xs">*</span>
                  </label>

                  <input
                    type="text"
                    name="mobile"
                    className={`form-control ${
                      errors?.mobile ? "invalid" : ""
                    }`}
                    autoComplete="new-password"
                    value={formData.mobile}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        mobile: e.target.value,
                      });

                      setErrors({
                        ...errors,
                        mobile: e.target.value
                          ? ""
                          : "Mobile Number is mandatory",
                      });
                    }}
                  />

                  <p className="text-danger font-size-xs m-0">
                    {errors?.mobile}
                  </p>
                </div>

                {/* Password */}

                <div className="col-md-12 mb-3">
                  <label className="form-label">
                    Password
                    <span className="text-danger font-size-xs">*</span>
                  </label>

                  <input
                    type="password"
                    name="password"
                    className={`form-control ${
                      errors?.password ? "invalid" : ""
                    }`}
                    value={formData.password}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        password: e.target.value,
                      });

                      setErrors({
                        ...errors,
                        password: e.target.value ? "" : "Password is mandatory",
                      });
                    }}
                  />

                  <p className="text-danger font-size-xs m-0">
                    {errors?.password}
                  </p>
                </div>

                {/* <div className="col-md-12 mb-3">
                  <label className="form-label">
                    Selfie Mode
                    <span className="text-danger font-size-xs">*</span>
                  </label>
                  <label className="checkbox checkbox-disabled">
                    <input
                      type="checkbox"
                      disabled="disabled"
                      checked="checked"
                      name="Checkboxes1"
                      value={formData.selfieMode}
                    />
                    <span></span>
                    
                  </label>
                </div>
               */}
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-primary font-weight-bold"
              data-dismiss="modal"
              ref={closeModalRef}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-primary font-weight-bold"
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAgentModal;
